import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DeviceManagerService } from '../../core/services/device-manager.service';
import { Album } from '../../api/albums/album.model';
import { AlbumManagerService } from '../../api/albums/album-manager.service';
import { TreeNode } from 'primeng/api';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
	selector: 'mycampapp-select-album-dialog',
	templateUrl: './select-album-dialog.component.html',
	styleUrls: ['./select-album-dialog.component.less']
})
export class SelectAlbumDialogComponent implements OnInit
{
	@Input() excludedAlbumId?: number;
	@Input() supportCanAcceptMedia = false;
	@Output() albumSelected = new EventEmitter<Album | undefined>();

	albums: TreeNode[] = [];
	loading = false;
	selectedAlbumNode?: TreeNode;
	visible = true;

	constructor(public deviceManager: DeviceManagerService,
	            private albumManager: AlbumManagerService) { }

	ngOnInit()
	{
		this.loadAlbum().subscribe( (nodes: TreeNode[]) => this.albums = nodes);
	}

	private loadAlbum(albumId: number = 0): Observable<TreeNode[]>
	{
		this.loading = true;
		return this.albumManager.getAlbum(albumId).pipe(map((album: Album) =>
			{
				if (this.excludedAlbumId != undefined)
					album.ChildAlbums = album.ChildAlbums.filter(album => album.Id !== this.excludedAlbumId);

				this.loading = false;
				return album.ChildAlbums.map(album => this.createTreeNodeFromAlbum(album));
			}));
	}

	onAlbumSelected(treeNode: TreeNode): void
	{
		if (this.selectedAlbumNode) this.selectedAlbumNode.styleClass = treeNode.styleClass?.replace(' selected', '');
		const album = treeNode.data;
		if (this.supportCanAcceptMedia && album.IsFolder) return;
		this.selectedAlbumNode = treeNode;
		treeNode.styleClass = treeNode.styleClass + ' selected';
	}

	onAlbumExpanded(treeNode: TreeNode): void
	{
		this.loading = true;
		this.loadAlbum(treeNode.data.Id).subscribe((nodes: TreeNode[]) => treeNode.children = nodes);
	}

	onOk(): void
	{
		this.albumSelected.emit(this.selectedAlbumNode === undefined ? null : this.selectedAlbumNode.data);
	}

	onHide(): void
	{
		this.albumSelected.emit(undefined);
	}

	private createTreeNodeFromAlbum(album: Album): TreeNode
	{
		return {
			data: album,
			label: album.Name,
			expanded: false,
			leaf: !album.IsFolder,
			styleClass: 'full-line-tree-node ' + (this.supportCanAcceptMedia && album.IsFolder ? 'album-not-selectable' : 'album-selectable'),
		};
	}
}
